import { render, staticRenderFns } from "./TExibition.vue?vue&type=template&id=02e2606a&scoped=true&"
import script from "./TExibition.vue?vue&type=script&lang=ts&"
export * from "./TExibition.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02e2606a",
  null
  
)

export default component.exports